import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';

import PickupSettingsContextProvider from '../contexts/pickup-settings-context';
import ShipFromPageErrorContextProvider from '../contexts/ship-from-page-error-context-provider';
import EditShipFromModalContextProvider from '../contexts/edit-ship-from-modal-context-provider';
import ShipFromSection from './ship-from-section';
import { useShipFrom } from '../../../../hooks/ship-froms/use-ship-from';

import PickPackTimeDropdown from './pick-pack-time-dd';
import PickupSettingsDaySchedule from './pickup-settings-day-schedule';
import PreferredPickupTime from './preferred-pickup-time';
import { PickupSettingsActionFooter } from './pickup-settings-action-footer';
import CarrierInstructionTextbox from './carrier-instruction-textbox';
import ShipFromContactDropdown from '../ship-from-row/ship-from-contact-dd';

import messages from '../messages';
import style from '../style.module.less';
import commonStyles from '../../settings-page.module.less';

export const EditPickupSettings = () => {
  const { shipFromId } = useParams();
  const editedShipFrom = useShipFrom(shipFromId);

  return (
    <PickupSettingsContextProvider shipFromId={shipFromId}>
      <div className={classnames(commonStyles.content, style['pickup-settings-wrapper'])}>
        <h2 className={style['pickup-settings-title']}>
          <FormattedMessage {...messages.pickupSettingsHeader} values={{ warehouseName: editedShipFrom?.name }} />
        </h2>
        <div className={style['edit-pickup-settings-page']}>
          <div className={style['pickup-info-wrapper']}>
            <ShipFromContactDropdown />
            <PickupSettingsDaySchedule />
            <PickPackTimeDropdown />
            <PreferredPickupTime />
            <CarrierInstructionTextbox />
            <PickupSettingsActionFooter />
          </div>
          <ShipFromPageErrorContextProvider>
            <EditShipFromModalContextProvider>
              <ShipFromSection />
            </EditShipFromModalContextProvider>
          </ShipFromPageErrorContextProvider>
        </div>
      </div>
    </PickupSettingsContextProvider>
  );
};
